// Candidate-consent error codes (BE contract §13) that can surface from any
// module. Checked as a fallback before the generic default message.
const consent = {
  err_consent_feature_unavailable: {
    message: 'Candidate consent is not available for this account.',
  },
  err_consent_not_enabled: {
    message: 'Candidate consent is not enabled for this account.',
  },
  err_consent_not_requestable: {
    message: 'A consent request cannot be sent in the current state.',
  },
  err_consent_template_missing: {
    message: 'Set up the consent email template in settings before requesting.',
  },
  err_consent_reminder_not_allowed: {
    message:
      'Reminder limit reached or last reminder was sent less than a day ago.',
  },
  err_consent_not_grantable: {
    message: 'Consent cannot be marked as granted for a candidate who refused.',
  },
  err_consent_not_required_when_refused: {
    message: 'A refused consent cannot be marked as not required.',
  },
  err_consent_not_withdrawable: {
    message: 'This consent cannot be withdrawn.',
  },
  err_consent_not_extendable: {
    message: 'Only granted consents can be extended.',
  },
  err_consent_processing_blocked: {
    message: 'This action is blocked because the candidate has not consented.',
  },
  err_already_anonymized: {
    message: 'This candidate is already anonymized.',
  },
  err_confirm_required_active_applications: {
    message:
      'This candidate has active applications. Confirm to anonymize anyway.',
  },
  err_empty_targets: {
    message: 'Select at least one candidate.',
  },
  // 403 raised on every write against an anonymized (GDPR-erased) candidate.
  err_contact_anonymized: {
    message:
      "This candidate has been anonymized (erased) and can't be modified.",
  },
  // Settings validation.
  err_mode_required: {
    message: 'Select a consent mode before enabling.',
  },
  // Settings duration_config validation (validity_config / data_retention_config).
  err_invalid_value: {
    message: 'Enter a duration between 1 and 999.',
  },
  err_invalid_unit: {
    message: 'Select a valid time unit (days, months, or years).',
  },
  // Policy text exceeds the storage limit (matched as a prefix — the BE appends the byte limit).
  err_text_size_cannot_be_greater_than: {
    message: 'The privacy policy text is too long. Please shorten it.',
  },
  err_url_must_be_a_valid_http_or_https_url: {
    message: 'Enter a valid http(s) URL for the privacy policy.',
  },
  err_file_size_limit_exceeded: {
    message: 'The privacy policy file is too large. Upload a smaller file.',
  },
  // Email offset out of range (prefix-matched — the BE appends the limit).
  err_offset_value_must_be_less_than_or_equal_to: {
    message: 'Email timing must be 999 or less.',
  },
};

export default consent;
